import { convertRemToPx } from '../../utils/utils'

export type ViewListenerState = 'mobile' | 'desktop'

export const getCurrentView = () =>
  window.innerWidth > convertRemToPx(48) ? 'desktop' : 'mobile'

export const initialViewListenerState = getCurrentView()
